import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { ticker } from "../../mock/mock";

const Message = ({ item, className }) => {
  const isTel = item.href && item.href.startsWith("tel:");
  const content = (
    <span className="inline-flex items-center gap-1.5 whitespace-nowrap text-[13px] font-medium text-[#0e0e10]/85">
      {item.label}{" "}
      <span style={{ color: "var(--tnf-blue)" }} className="font-semibold">
        {item.accent}
      </span>
    </span>
  );
  const wrapCls = `absolute inset-0 flex items-center justify-center ${className}`;
  return isTel ? (
    <a href={item.href} className={wrapCls}>
      {content}
    </a>
  ) : (
    <Link to={item.href} className={wrapCls}>
      {content}
    </Link>
  );
};

const Marquee = () => {
  const [index, setIndex] = useState(0);
  const [prev, setPrev] = useState(null);
  const timer = useRef(null);

  const advance = () => {
    setIndex((i) => {
      setPrev(i);
      return (i + 1) % ticker.length;
    });
  };

  const start = () => {
    stop();
    timer.current = setInterval(advance, 3500);
  };
  const stop = () => {
    if (timer.current) clearInterval(timer.current);
  };

  useEffect(() => {
    start();
    return stop;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // clear the outgoing message after its animation completes
  useEffect(() => {
    if (prev === null) return;
    const t = setTimeout(() => setPrev(null), 550);
    return () => clearTimeout(t);
  }, [prev, index]);

  return (
    <div
      className="fixed top-0 left-0 right-0 z-[55] bg-[#f6f7f9] border-b border-black/5 overflow-hidden"
      style={{ height: "40px" }}
      onMouseEnter={stop}
      onMouseLeave={start}
    >
      <div className="relative h-full max-w-[680px] mx-auto px-4">
        {prev !== null && (
          <Message
            key={`prev-${prev}`}
            item={ticker[prev]}
            className="tnf-announce-out"
          />
        )}
        <Message
          key={`cur-${index}`}
          item={ticker[index]}
          className="tnf-announce-in"
        />
      </div>
    </div>
  );
};

export default Marquee;
